import { EMPTY, expand, retry, switchMap, timer } from "rxjs";
import { queryPublishResult$, UserPublishResultResponse } from "@apis/http/api";
import { UserPublishResultResponseStatus } from "@apis/generated/openapi";

export const POLL_INTERVAL_MS = 3000;
export const POLL_RETRY_COUNT = 3;

/** 终态：SUCCESS / FAIL / PRE_CHECK_FAIL（terminal）或定时发布已排程（PENDING_PUBLISH） */
export const isPublishResultFinal = (next: UserPublishResultResponse) =>
  next.terminal || next.status === UserPublishResultResponseStatus.PENDING_PUBLISH;

/** 返回 true 表示需要继续轮询；与 isPublishResultFinal 对齐，额外在 needConfirm 时停止等待用户确认 */
export const shouldContinuePolling = (next: UserPublishResultResponse) =>
  !isPublishResultFinal(next) && !next.needConfirm;

/**
 * 串行轮询发布结果：先请求一次，若仍需继续则 delay 后再请求，直到终态/需确认。
 * 基于 expand 天然串行——上一响应返回后才 schedule 下一次，不会出现并发 pending。
 */
export const createPublishResultPoll$ = (postRecordId: number) =>
  queryPublishResult$({ id: postRecordId }).pipe(
    expand((next) =>
      shouldContinuePolling(next)
        ? timer(POLL_INTERVAL_MS).pipe(switchMap(() => queryPublishResult$({ id: postRecordId })))
        : EMPTY,
    ),
    retry({
      count: POLL_RETRY_COUNT,
      delay: () => timer(POLL_INTERVAL_MS),
      resetOnSuccess: true,
    }),
  );
